import { gql } from '@apollo/client';
import { SH_PLAYER_FRAGMENT, ERROR_FRAGMENT } from './fragments.js';

export const GET_SH_ASSISTANT_SUGGESTIONS = gql`
  query GetShAssistantSuggestions($input: _SH_AssistantSuggestionsInput!) {
    _SH_ {
      id
      assistantSuggestions(input: $input) {
        ok
        playerSuggestions {
          userId
          score
          playedCount
          lastPlayedAt
          reasons {
            code
            label
            weight
          }
          player {
            ...ShPlayerFields
          }
        }
        lineupProposals {
          id
          sourceMatchId
          sourceMatchStartAt
          score
          reasons {
            code
            label
            weight
          }
          players {
            team
            position
            userId
            name
            player {
              ...ShPlayerFields
            }
          }
        }
        reservationProposals {
          id
          methodKey
          structureId
          fieldId
          fieldName
          sportType
          startAt
          endAt
          score
          confidence
          reasonSummary
          secondaryTags
          learningSignals {
            type
            key
            value
          }
          proposalDedupKey
          proposalSemanticDedupKey
          reasons {
            code
            label
            weight
          }
          organizer {
            userId
            name
            email
            phone
          }
          players {
            team
            position
            userId
            name
            player {
              ...ShPlayerFields
            }
          }
        }
        reservationMethods {
          key
          label
          description
          meta {
            totalCandidates
            totalCompatible
            returned
            hasMore
            page
            pageSize
            totalPages
            activeParams
            learningSampleSize
            learningMultiplier
            learningStatus
          }
          explain {
            playersConsidered
            sourceMatchesConsidered
            availabilityWindowsConsidered
            topAvailabilitySlots {
              key
              count
            }
            topClientTags {
              tag
              count
            }
            levelDistribution {
              bucket
              count
            }
            tesseratiCount
            nonTesseratiCount
          }
          proposals {
            id
            methodKey
            structureId
            fieldId
            fieldName
            sportType
            startAt
            endAt
            score
            confidence
            reasonSummary
            secondaryTags
            learningSignals {
              type
              key
              value
            }
            proposalDedupKey
            proposalSemanticDedupKey
            reasons {
              code
              label
              weight
            }
            organizer {
              userId
              name
              email
              phone
            }
            players {
              team
              position
              userId
              name
              player {
                ...ShPlayerFields
              }
            }
          }
        }
        insights {
          acceptedLast30d
          paidLast30d
          paidConversionRateLast30d
          topMethodKey
          topPaidMethodKey
          learningActive
        }
        error {
          ...ErrorFields
        }
      }
    }
  }
  ${SH_PLAYER_FRAGMENT}
  ${ERROR_FRAGMENT}
`;
